import { logEvent } from './logGaEvent'

const logFilterResetOverfilter = () => {
  logEvent('filter', {
    filter_type: 'static',
    filter_name: 'reset',
    product_name: 'air',
    page_name: 'listings',
  })
}

export { logFilterResetOverfilter }
